import { useLogin } from "../components/login/context/LoginContext";

import { Button, Text } from '@ui-component-library';

import { TailwindWrapper } from "@utils/TailwindWrapper";

export default function MyAccountForm() {
    const LoginContext = useLogin();

    const next = () => {
        if(LoginContext.isLogged) {
            window.open('/min-skog/', '_self')
        } else {
            LoginContext.setShow(true);
        }
    }

    return <>
        <TailwindWrapper>
            <div className='flex justify-center w-full'>
                <div className='bg-white rounded rounded-2xl p-8'>
                    <Text variant='subheaderSmallMedium' className='mb-4'>Välkommen</Text>

                    <Text variant='bodySmallRegular'>{LoginContext.isLogged ? 'Börja utforska alla fördelar med att ha din skogsbruksplan digitalt.' : 'Skapa ett konto eller logga in för att börja skapa din digitala skogsbruksplan.'}</Text>

                    <Button tw variant='primary' className='w-full mt-4' onClick={next}>{LoginContext.isLogged ? 'Till min skogsbruksplan' : 'Skapa konto / Logga in'}</Button>
                </div>
            </div>
            
        </TailwindWrapper>
    </>
}
